export default __webpack_public_path__ + "static/katimex-64322fa5169e432e07a8c4d010dcd496.jpg";